import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { Sheet } from '@/components/common/Sheet';

/**
 * Il foglio «Lasciare il tavolo?» — la conferma prima che un tocco sulla barra smonti un tavolo di backgammon col MIO orologio
 * che corre (I-392, Luca «4 (b)»). Quando serve lo decide `lib/qgammon/lasciareIlTavolo.ts`; chi lo apre e' `TabBar`.
 *
 * ⚠️ «Resta» e' il PRIMARIO e la via di fuga: il foglio si chiude anche col velo, trascinandolo e col tasto indietro di Telegram
 * (`Sheet`), e in tutti e tre i casi si resta. Solo «Esci» porta fuori. L'azione che costa e' la meno evidente apposta.
 * Lo apre anche il tasto indietro di Telegram dal tavolo (Luca, I-402): v. `contexts/UscitaTavoloContext.tsx`. Con il foglio aperto
 * l'indietro lo chiude, come «Resta» (e' un livello di `Sheet`): non apre una seconda conferma.
 */
export function ConfermaLasciaTavolo({
  open,
  onResta,
  onEsci,
}: {
  open: boolean;
  /** Chiude il foglio e basta: nessuna navigazione. */
  onResta: () => void;
  /** Lascia il tavolo verso la voce toccata. */
  onEsci: () => void;
}) {
  const { t } = useTranslation('activeMatch');
  return (
    <Sheet open={open} onClose={onResta} label={t('leaveTable.title')}>
      <div className="flex flex-col gap-4 px-6 pb-2 pt-4 text-center" data-testid="conferma-lascia-tavolo">
        <h2 className="text-lg font-bold text-fg">{t('leaveTable.title')}</h2>
        <p className="text-sm text-fg-muted">{t('leaveTable.body')}</p>
        <div className="flex flex-col gap-2 pt-2">
          <Button fullWidth data-testid="conferma-lascia-tavolo-resta" onClick={onResta}>
            {t('leaveTable.stay')}
          </Button>
          <Button variant="neutro" fullWidth data-testid="conferma-lascia-tavolo-esci" onClick={onEsci}>
            {t('leaveTable.leave')}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
